"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUniqueHtmlId = void 0;
var _react = require("react");
var _lodash = require("lodash");
var createId = function createId(baseString) {
  var rand = Math.random().toString(36).slice(2);
  var slug = (0, _lodash.kebabCase)((0, _lodash.truncate)(baseString, {
    length: 24
  })) || 'anon';
  return "".concat(slug, "-").concat(rand);
};
var useUniqueHtmlId = function useUniqueHtmlId(baseString) {
  return (0, _react.useMemo)(function () {
    return createId(baseString);
  }, [baseString]);
};
exports.useUniqueHtmlId = useUniqueHtmlId;